module.exports = __webpack_public_path__ + "static/media/session_preview.94125d49.PNG";